"use client";

import { SectionError } from "@/components/ui/section-error";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <SectionError
      error={error}
      reset={reset}
      scope="shell-no-navbar"
      title={"This page failed to load"}
      description={"Retrying usually fixes it."}
    />
  );
}
